<template>
  <div class="admin-tab teams">
    <wb-datatable
      v-bind="tableProps"
      :disallowDeleting="true"
      :disallowEditing="true"
      :allowCreation="false"
      :searchKey="'name'"
      :customControls="[
        {
          icon: 'add',
          name: 'Add parent team',
          handler: (row) => {
            openDialog(row);
          }
        },
        {
          icon: 'delete',
          name: 'Remove parent team',
          handler: (row) => {
            openConfirmDialog(row);
          }
        },
      ]"
    ></wb-datatable>
    <md-dialog ref="dialog">
      <md-dialog-title>Edit team assignment</md-dialog-title>

      <md-dialog-content>
        <form v-if="organization">
          <div class="teams-list">
            <p>Team name</p>
            {{organization.name}}
          </div>
          <div class="teams-list">
            <p>Team id</p>
            {{organization.id}}
          </div>
          <div class="teams-list" v-if="organization && organization.parentTeams && organization.parentTeams.length > 0">
            <p>Parent teams</p>
            {{organization.parentTeamsNames}}
          </div>
          <div class="teams-list" v-if="organization && organization.childTeams && organization.childTeams.length > 0">
            <p>Child teams</p>
            {{organization.childTeamsNames}}
          </div>
          <md-input-container>
            <multiselect
              v-model="newTeam"
              :options="newParentTeam"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :label="'name'"
              placeholder="Assign to another parent team"
              selectLabel=''
            >
            </multiselect>
          </md-input-container>
        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeDialog(false)">Cancel</md-button>
        <md-button class="md-primary" @click="closeDialog(true)">Add</md-button>
      </md-dialog-actions>
    </md-dialog>


    <md-dialog ref="confirmDialog">
      <md-dialog-title>Are you sure you want to remove this team from the selected parent team?</md-dialog-title>

      <md-dialog-content>
        <form v-if="organization">
          <div class="teams-list">
            <p>Team name</p>
            {{organization.name}}
          </div>
          <div class="teams-list">
            <p>Team id</p>
            {{organization.id}}
          </div>
          <md-input-container>
            <multiselect
              v-model="oldParentTeam"
              :options="parentTeamsList"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :label="'name'"
              placeholder="Remove from parent team"
              selectLabel=''
            >
            </multiselect>
          </md-input-container>
          
        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeConfirmDialog(false)">Cancel</md-button>
        <md-button class="md-primary" @click="closeConfirmDialog(true)">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>


  </div>
</template>

<script>
import wbDataTable from 'WBDataTable';
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
  name: 'AdminOrganizations',
  components: {
    'wb-datatable': wbDataTable,
    Multiselect
  },
  data() {
    return {
      organization: null,
      newTeam: null,
      oldParentTeam: null,
      newParentTeam: [],
      parentTeamsList: [],
      isNew: false,
      tableProps: {
        dataext: [],
        columns: null,
        hasControls: true,
        allowCreation: true,
        disableSearch: false,
        pagination: {
          size: 50
        },
      },
      tableColumns: [
        {name: 'id', displayName: 'ID', visible: true, type:'number', isEditable:false},
        {name: 'name', displayName: 'Team', visible: true, type:'string', isEditable:false},
        {name: 'childTeamsNames', displayName: 'Child Teams', visible: true, type:'string', isEditable:false},
        {name: 'parentTeamsNames', displayName: 'Parent Teams', visible: true, type:'string', isEditable:false},
      ],
    }
  },
  validations: {
  },
  computed: {
    ...mapGetters([
      'teams',
      'teamsAssigned'
    ])
  },
  methods: {
    getTeams() {
      this.$store.dispatch('getTeams')
        .then(() => {
          this.tableProps.dataext = [];
          this.$nextTick(() => {
            this.getAssignedTeams();
          });
        });
    },
    getAssignedTeams() {
      this.$store.dispatch('getAssignedTeams')
        .then(()=>{
          this.setAssignedTeams();
        })
    },
    setAssignedTeams(){
      this.teams.forEach((team)=>{

        team.parentTeams = [];
        team.childTeams = [];
        team.parentTeamsNames = [];
        team.childTeamsNames = [];
        
        team.childTeams = this.teamsAssigned.filter((teamAssigned)=>{
          return teamAssigned.parentId === team.id
        })

        team.childTeams.forEach((childTeam) => {
          this.teams.forEach((team)=>{
            if(team.id===childTeam.childId){
              childTeam.name = team.name;
            }
          })
          team.childTeamsNames.push(childTeam.name)
        })

        team.parentTeams = this.teamsAssigned.filter((teamAssigned)=>{
          return teamAssigned.childId === team.id
        })
        

        team.parentTeams.forEach((parentTeams) => {
          this.teams.forEach((team)=>{
            if(team.id===parentTeams.parentId){
              parentTeams.name = team.name;
            }
          })
          team.parentTeamsNames.push(parentTeams.name)
        })

        team.parentTeamsNames = team.parentTeamsNames.join(', ');
        team.childTeamsNames = team.childTeamsNames.join(', ');
      })
      this.tableProps.dataext = JSON.parse(JSON.stringify(this.teams));
    },
    openDialog(row) {
      if (row) {
        this.organization = row;
        this.newTeam = null;
        this.newParentTeam = [];
        this.teams.forEach((adminTeam)=>{
        let isTeam = this.organization.parentTeams.find((parentTeam)=>{
          return adminTeam.id === parentTeam.parentId;
        })
        if(!isTeam){
          this.newParentTeam.push(adminTeam)
        }
      })
      this.newParentTeam = this.newParentTeam.filter((team)=>{
        if(!(team.id === this.organization.id)){
          return team
        }
      })
      }
      this.$refs.dialog.open();
    },
    closeDialog(isSaved) {
      if (isSaved) {
        let data = {
          parentId: this.newTeam.id,
          childId: this.organization.id,
        }
        this.$store.dispatch('updateTeamsAssignment', data)
        this.getTeams();
      }
      this.$refs.dialog.close();
      this.organization = null;
    },
    openConfirmDialog(row) {
      this.organization = row;
      this.oldParentTeam = null;
      this.parentTeamsList = [];
      let parentTeams = this.teamsAssigned.filter((team)=>{
          return team.childId === this.organization.id
        })
        parentTeams.forEach((parentTeam) => {
          this.teams.forEach((team)=>{
            if(team.id===parentTeam.parentId){
              parentTeam.name = team.name;
            }
          })
          this.parentTeamsList.push(parentTeam)
        })

      this.$refs.confirmDialog.open();
    },
    closeConfirmDialog(isConfirmed) {
      console.log('this.oldParentTeam', this.oldParentTeam)
      if (isConfirmed) {
        let data = {
          parentId: this.oldParentTeam.parentId,
          childId: this.organization.id,
        }
        this.$store.dispatch('deleteFromParentTeam', data)
          .then(() => {
             this.$store.dispatch('getAssignedTeams');
          })
        this.getTeams();
      }
      this.$refs.confirmDialog.close();
    },
  },
  mounted() {
    this.tableProps.columns = this.tableColumns;
    this.getTeams();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .teams tr .id.md-table-cell{
    width: 30% !important;
  }
  .teams .md-table .md-table-cell .md-table-cell-container{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// AdminTeams.vue?22248a75